module.exports = __webpack_public_path__ + "img/5-营销互动-02.c848a562.png";